import { render, staticRenderFns } from "./RestorePassword.vue?vue&type=template&id=6a18346c&scoped=true&"
import script from "./RestorePassword.js?vue&type=script&lang=js&"
export * from "./RestorePassword.js?vue&type=script&lang=js&"
import style0 from "./RestorePassword.vue?vue&type=style&index=0&id=6a18346c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a18346c",
  null
  
)

export default component.exports